import { Component, OnInit } from '@angular/core';
import { AddressListDialogComponent } from 'projects/shared/lib/components/shared/address/list-dialog/address-list-dialog.component';

@Component({
    selector: 'app-address-list-dialog',
    templateUrl: './address-list-dialog.component.html',
    standalone: false
})
export class AddressListDialogMHComponent extends AddressListDialogComponent implements OnInit {

  ngOnInit() {
    this.checkForTour();
  }

  private checkForTour() {
    this.addressList = this.addressList?.filter(a => {
      let toursExist = a.tourList != undefined && a.tourList.length > 0;
      return toursExist;
    });
  }
}
